import moment from 'moment'

export const convertTime = time => (moment.utc(time).format('mm:ss'))

export default convertTime
